<template>
  <div class="role-container">
    <div class="role-tree" v-if="!this.userInfo.storeId">
      <el-tree
        v-loading="loading"
        ref="treeRef"
        node-key="id"
        :default-expand-all="true"
        :highlight-current='true'
        :current-node-key="currentKey"
        :expand-on-click-node="false"
        :data="treeData"
        :props="defaultProps"
        @node-click="handleNodeClick"
      ></el-tree>
    </div>
    <div class="role-table">
      <page-template
        ref="roleTemplate"
        :tableOptions="tableOptions"
        :searchOptions="searchOptions"
        :toolConfig="toolConfig"
        :addColumns="addColumns"
        :editColumns="editColumns"
        @getDetail="getDetail"
      ></page-template>
    </div>
    <el-dialog title="分配权限" :visible.sync="allot" width="600px" height="500px" :close-on-click-modal="false">
      <menu-tree-template v-if="allot" ref="menuTree" :treeConfig="treeConfig"></menu-tree-template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitAuth" type="primary">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="店小二权限分配" :visible.sync="appletShow" width="600px" height="500px" :close-on-click-modal="false">
      <menu-tree-template v-if="appletShow" ref="appletMenuTree" :treeConfig="appletTreeConfig"></menu-tree-template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="appletSave" type="primary">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import menuTreeTemplate from "@/components/business/menuTreeTemplate";

export default {
  components: {
    pageTemplate,
    menuTreeTemplate
  },
  data() {
    return {
      storeClass: '',
      loading: false,
      treeData: [],
      currentKey: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      appletShow: false,
      allot: false,
      treeConfig: {
        id: 'menuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: api.system.rolePrivilege,
          param: {id: ''}
        }
      },
      appletTreeConfig: {
        id: 'appletMenuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: '/api/eros/wa/waMenu/privilege',
          param: {id: ''}
        }
      },
      // 高级搜索条件
      searchOptions: {
        simple: [
          {label: "", prop: "name", ifFuzzy: true, type: "input", labelWidth: '80', placeholder: "请输入角色名称"},
          // {label: "编码", prop: "code", type: "input",labelWidth:'80'},
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert'
        },
        {
          label: '修改',
          code: 'update',
          type: this.$utils.buttonType.tableOperate
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate
        },
        {
          label: '配置权限',
          code: 'permission',
          more: true,
          type: this.$utils.buttonType.tableOperate,
          callback: this.allotMenu
        },
        {
          label: '店小二权限配置',
          code: 'waiter',
          more: true,
          type: this.$utils.buttonType.tableOperate,
          callback: this.appletRole
        }
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          // {
          //   label: '编码',
          //   prop: 'code',
          //   width: '80',
          //   align: 'center',
          // },
          {
            label: '角色名称',
            prop: 'name',
            width: '120',
            align: 'center',
          },
          // {label: '角色类型', prop: 'remarks', width: '120', align: 'center'},
          // {label: '允许授权', prop: '', width: '80', align: 'center'}
        ],
        url: api.system.role,
        param: {}
      },
      // 添加字段
      addColumns: {
        labelWidth: '130px',
        columns: [
          {
            label: "门店",
            type: "select",
            prop: "storeId",
            span: 12,
            // defaultValue:-1,
            data: [],
            isHasAll: true,
            url: api.store.store,
            rule: [
              {required: true, message: '请选择门店', trigger: 'change'},
            ],
          },
          {
            label: '角色名称',
            type: 'input',
            prop: 'name',
            change: this.checkName,
            maxLength: 16,
            rule: [
              {required: true, message: '请输入名称', trigger: 'blur'},
              {
                min: 2,
                max: 16,
                message: '长度在 2 到 15 个字符',
                trigger: 'blur'
              }
            ],
            span: 12
          },
          // {
          //   label: '角色编号',
          //   type: 'input',
          //   prop: 'code',
          //   span: 12
          // },

          // {
          //   label: '角色类型',
          //   type: 'input',
          //   prop: 'roleType',
          //   isShow: false,
          //   // defaultValue: 19910,
          //   span: 12
          // },
        ],
        url: api.system.role
      },
      // 编辑
      editColumns: {
        labelWidth: '130px',
        columns: [
          {
            label: "门店",
            type: "select",
            prop: "storeId",
            span: 12,
            data: [],
            isHasAll: true,
            disabled: true,
            url: api.store.store,
          },
          {
            label: '角色名称',
            type: 'input',
            prop: 'name',
            maxLength: 16,
            change: this.checkNameEdit,
            rule: [
              {required: true, message: '请输入名称', trigger: 'blur'},
              {
                min: 2,
                max: 16,
                message: '长度在 2 到 15 个字符',
                trigger: 'blur'
              }
            ],
            span: 12
          },
          // {
          //   label: '角色编号',
          //   type: 'input',
          //   prop: 'code',
          //   span: 12
          // },
        ],
        url: api.system.role
      },
      userInfo: {},
    };
  },
  created() {
    this.userInfo = this.$utils.getSysUser()
    this.getStoreList()
  },
  mounted() {
    let storeId = this.addColumns.columns.filter(v => v.prop == 'storeId')[0]
    if (!this.userInfo.storeId) {
      this.currentKey = ''//当前选中的节点
      this.tableOptions.param.storeId = ''
      this.$refs['treeRef'].setCurrentKey(this.currentKey)
      storeId.defaultValue = -1
    } else {
      storeId.disabled = true
      storeId.defaultValue = this.userInfo.storeId
    }
  },
  methods: {
    // 获取门店
    getStoreList() {
      this.loading = true
      this.$axios.fetchPost(api.store.store + '/list', {}).then(res => {
        if (res.code === 200 && res.data) {
          this.treeData.push({
            id: '',
            name: '总部',
            // name: this.$utils.getSysUser().merchantName,
            children: res.data,
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 点击门店
    handleNodeClick(data) {
      this.storeClass = '';
      this.tableOptions.param.storeId = data.id
      this.$refs.roleTemplate.operationSuccess()
      let storeId = this.addColumns.columns.filter(v => v.prop == 'storeId')[0]
      if (data.id) {
        storeId.defaultValue = data.id
        this.storeClass = data.storeClass;
      } else {
        storeId.defaultValue = -1
      }
    },
    // 点击小程序分配权限
    appletRole(val) {
      this.appletShow = true
      this.appletTreeConfig.request.param.id = val.id;
      this.$nextTick(() => {
        this.$refs.appletMenuTree.getTreeData();
      });
    },
    //小程序权限提交
    appletSave() {
      this.$refs.appletMenuTree.loading = true;
      this.$axios.fetchPost('/api/eros/wa/waMenu/privilege', {
        privilegeIds: this.$refs.appletMenuTree.getCheckedIds(),
        id: this.appletTreeConfig.request.param.id
      }).then(data => {
        if (data.code === 200) {
          this.$notify({
            type: "success",
            title: '提交操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '操作成功!'});
          this.appletShow = false;
        } else {
          this.$message({message: data.errorMsg, type: 'error'});
        }
      });
    },

    //分配权限
    allotMenu(data) {
      this.allot = true;
      this.treeConfig.request.param.id = data.id;
      this.$nextTick(() => {
        let params = {name: data.name, type: data.type, storeClass: this.storeClass};
        this.$refs.menuTree.getTreeData(params);
      });
    },

    //提交权限
    submitAuth() {
      console.log(this.$refs.menuTree.getCheckedIds())
      this.$refs.menuTree.loading = true;
      this.$axios.fetchPost(api.system.rolePrivilege, {
        privilegeIds: this.$refs.menuTree.getCheckedIds(),
        id: this.treeConfig.request.param.id
      }).then(data => {
        if (data.code === 200) {
          this.$notify({
            type: "success",
            title: '提交操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '操作成功!'});
          this.allot = false;
        } else {
          this.$message({message: data.errorMsg, type: 'error'});
        }
      });
    },
    checkName(form) {
      this.$axios.fetchPost(api.system.role + '/check/role/name', {
        name: form.name,
        storeId: form.storeId
      }).then(data => {
        if (data.code === 200) {
          if (data.data === true) {
            this.$message({type: 'warning', message: '角色名称重复'});
            form.name = '';
            throw '角色名称重复'
          }
        } else {
          this.$message({type: 'error', message: data.msg});
        }
      })
    },
    getDetail(form) {
      this.editData = this.$utils.deepClone(form);
    },
    checkNameEdit(form) {
      if (this.editData.name !== form.name) {
        this.checkName(form);
      }
    }
  }
};
</script>
<style scoped>
  .role-container {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .role-tree {
    min-width: 15%;
    height: 100%;
    padding: 16px;
    overflow: scroll;
  }

  .role-table {
    flex: 1;
    /*padding:0 10px 10px 10px;*/
  }

</style>



// WEBPACK FOOTER //
// src/page/system/maintain/nowRole.vue